module.exports = __webpack_public_path__ + "img/adv-individual.d3cd7897.png";